export const ABB_PRODUCT_NAME_LOCALIZED_KEY = 'productABBProductNameLocalized';
export const STORY_BODY_A_KEY = 'productLongIntroA';
export const PRODUCT_PDP_META_DESCRIPTION = 'productPdpMetaDescription';
export const PRODUCT_PDP_META_TITLE = 'productPdpMetaTitle';
export const PRODUCT_PHOTO_DISCLAIMER_KEY = 'productPhotoDisclaimer';
export const E_COMMERCE_ENABLED_KEY = 'eCommerceEnabled';
export const PRODUCT_CAMPAIGN_ID_KEY = 'productCampaignID';
export const PRODUCT_SHORT_INTRO = 'productShortIntro';
export const PRODUCT_OVERVIEW_HEADER = 'productOverviewHeader';
export const PRODUCT_LONG_INTRO_B = 'productLongIntroB';
export const PRODUCT_LONG_INTRO_C = 'productLongIntroC';
export const DELIVERY_TEXT = 'deliveryText';
export const RETURN_TEXT = 'returnText';
export const WARRANTY_TEXT = 'warrantyText';
export const PRODUCT_BLOCK_STRATEGY = 'productBlockStrategy';
export const PART_CODE = 'partCode';
export const PRODUCT_DRIVER_LICENCE_CATEGORY = 'productDriverLicenceCategory';
export const ELECTRIC_VEHICLE_ICON = 'electricVehicleIcon';
export const PRODUCT_YEAR_ATTR = 'productYear';
export const ENABLED_FOR_TEST_RIDE_ATTR = 'enabledForTestRide';
export const ARCHIVE_PRODUCT_ATTR = 'archiveProduct';
export const COLLECTION_PRODUCT_ATTR = 'collection';
export const LEASING_ENABLED_KEY = 'leasingEnabled';
export const PRODUCT_SERVICE_CODES = 'productServiceCodes';
export const G_CORE_CLASS = 'gCoreClass';
export const ACCESSORY_TYPE_EN = 'accessoryTypeEn';
export const G_CORE_PRODUCT_GROUP_NAME = 'gCoreProductGroupName';
// Keys for filter (from attributes value)
export const COLOR_ID_KEY = 'colourId';
export const COLOR_NAME_KEY = 'colourName';
export const GENDER_KEY = 'gender';
export const COLOR_CODE_KEY = 'colourCode';
export const ROTATION_KEY = 'rotation';
export const SHAFT_LENGTH_KEY = 'shaftLength';
export const STARTING_METHOD_KEY = 'startingMethod';
export const CONTROL_METHOD_KEY = 'controlMethod';
export const POWER_METHOD_KEY = 'power';
export const TRANSMISSION_METHOD_KEY = 'transmission';
export const LOWERED_VERSION_METHOD_KEY = 'loweredVersion';
export const SIZE_KEY = 'size';
export const LENGTH_KEY = 'length';
export const MOTORCYCLE_POWER_VERSION_KEY = 'productMotorcyclePowerVersion';
export const MOTORCYCLE_TRANSMISSION_KEY = 'productMotorcycleTransmission';
export const MOTORCYCLE_LOWERED_VERSION_KEY = 'productMotorcycleLoweredVersion';
export const PRODUCT_TYPE_KEY = 'productType';
export const PRODUCT_NAME_KEY = 'productName';
export const PRODUCT_NAME_EXTENDED_KEY = 'productNameExtended';
export const PRICING_DISCLAIMER_KEY = 'pricingDisclaimer';
export const PRICE_DISCOUNT_HISTORY = 'priceDiscountHistory';
export const PRODUCT_OPTIONS_KEY = 'productOptions';
export const ENABLE_NOTIFY_ME = 'enableNotifyMe';
export const PRODUCT_OPTION_KEY = 'productOption';
// Extra custom keys
export const PRICE_KEY = 'price';
export const FINAL_PRICE_KEY = 'finalPrice';
export const PRODUCT_NOTIFY_ME_DISCLAIMER = 'productNotifyMeDisclaimer';
export const PRODUCT_PAGE_HEADING_1 = 'productPageHeading1';
export const PRODUCT_PAGE_HEADING_2 = 'productPageHeading2';
export const ACCESSORY_PDP_HEADING_2 = 'accessoryPdpHeading2';
export const PRODUCT_MOTORCYCLE_TRANSMISSION = 'productMotorcycleTransmission';
export const PRODUCT_MOTORCYCLE_POWER_VERSION = 'productMotorcyclePowerVersion';
export const ACCESSORY_HIDE_PRODUCT_COMPATIBILITY = 'accessoryHideProductCompatibility';
export const SHOW_NEW_LABEL = 'showNewLabel';
export const SHOW_NEW_LABEL_UNTIL = 'showNewLabelUntil';
// Cart Groups options
export const PRODUCT_TYPE_MARINE_ENGINES_KEY = 'MarineEngines';
export const PRODUCT_TYPE_MARINE_ENGINE_KEY = 'MarineEngine';
export const PRODUCT_TYPE_MOTORCYCLES_KEY = 'motorcycles';
export const PRODUCT_TYPE_MOTORCYCLE_KEY = 'motorcycle';
export const PRODUCT_TYPE_SCOOTERS_KEY = 'scooters';
export const PRODUCT_TYPE_SCOOTER_KEY = 'scooter';
export const PRODUCT_TYPE_EBIKES_KEY = 'eBikes';
export const PRODUCT_TYPE_EBIKE_KEY = 'eBike';
export const PRODUCT_TYPE_BOATS_KEY = 'boats';
export const PRODUCT_TYPE_BOATS_YAM_KEY = 'yam';
export const PRODUCT_TYPE_BOATS_INFLATABLES_KEY = 'inflatables';
export const DEFAULT_PRICE_PROPS = {
    amount: 0,
    currencyCode: '',
    validFrom: '',
    validUntil: '',
    country: '',
};
export const PORTUGAL_COUNTRY_CODE = 'PT';
export const CATEGORY_SUFFIX = 'acc';
export const DEFAULT_MOTORCYCLES_EXTRA_ATTRS_EN = {
    power35kw: '35 kW (A2 licence)',
    fullPower: 'Full power',
    yAMTTransmission: 'Y-AMT',
    standardTransmission: 'Standard 6-speed manual',
    loweredVersion: 'Yes',
    notLoweredVersion: 'No',
};
export const SEARCH_HISTORY_KEY = 'SearchHistory';
